"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.configService = exports.loadConfiguration = exports.publicRuntimeConfig = exports.serverRuntimeConfig = exports.get = void 0;
/* eslint-disable max-len */
var backendTechUrl = process.env.BACKEND_TECH_URL;
var backendVisUrl = process.env.BACKEND_VIS_URL;
var backendSelUrl = process.env.BACKEND_SEL_URL;
var backendBuyUrl = process.env.BACKEND_BUY_URL;
var gatewayUrl = process.env.GATEWAY_URL;
var merchantCenterStrapiUrl = process.env.MERCHANT_CENTER_STRAPI_URL;
var backendRfnUrl = process.env.BACKEND_RFN_URL;
var backendRefUrl = process.env.BACKEND_REF_URL;
var backendDispUrl = process.env.BACKEND_DISP_URL;
var backendCompUrl = process.env.BACKEND_COMP_URL;
// backend WS is used when testing JAHIA content that use flux directly from production (home)
var backendWsUrl = process.env.BACKEND_WS_URL;
var apiUrl = process.env.API_URL || process.env.API_TECH;
var apiTech = process.env.API_TECH;
var apiVis = process.env.API_VIS;
var apiSeller = process.env.API_SELLER;
var apiBuyer = process.env.API_BUYER;
var apiMerch = process.env.API_MERCH;
var apiStrapi = process.env.API_STRAPI;
var canonicalUrl = process.env.CANONICAL_URL || 'https://fr.shopping.rakuten.com';
var domainName = 'https://fr.shopping.rakuten.com';
var enableProxification = process.env.BACKEND_PROXIFICATION === 'true';
var enableBackendHttpProxy = process.env.USE_BACKEND_HTTP_PROXY === 'true'; // Allow the use of a Http proxy between node and WS e.g chares. https://confluence.rakuten-it.com/confluence/display/PRIC/Http+Request+between+Canopy+and+Scala+Gateway+inspection
var enableBackendHttpProxyServerUrl = process.env.HTTP_PROXY; // Allow the use of a Http proxy between node and WS e.g chares. https://confluence.rakuten-it.com/confluence/display/PRIC/Http+Request+between+Canopy+and+Scala+Gateway+inspection
var httpsPort = process.env.HTTPS_PORT;
var nodeInstance = process.env.NODE_INSTANCE;
var filterFamilyIsActive = process.env.FEATURE_FLIPPING_FILTER_FAMILY_IS_ACTIVE === 'true';
var kmlEndpoint = process.env.KML_ENDPOINT || 'https://fr.shopping.rakuten.com/visuels/0_Kameleoon/tagIntegration/kameleoon.js';
var kmlIframeUrl = process.env.KAMELEOON_IFRAME_URL || '/visuels/0_Kameleoon/tagIntegration/kameleoon-iframe.html?fallback=1';
var kmlIsActive = process.env.KAMELEOON_IS_ACTIVE === 'true';
var cdn = process.env.CDN || '/vstatic/0/';
var cdnStatic = process.env.CDN_STATIC_BASE_URL || cdn;
var cdnImages = process.env.CDN_IMAGES || process.env.CDN;
var defaultTimeout = parseInt(process.env.TIMEOUT_DEFAULT, 10) || 2000;
var longTimeout = parseInt(process.env.TIMEOUT_LONG, 10) || 5000;
var lazyOffsetDesktop = parseInt(process.env.LAZY_OFFSET_DESKTOP, 10) || 1000;
var lazyOffsetMobile = parseInt(process.env.LAZY_OFFSET_MOBILE, 10) || 600;
var lockMaxFlux = parseInt(process.env.LOCK_MAX_FLUX, 10) || 0;
var hasCanopy = !process.env.AB_ROUTE;
var xitiSiteDesktop = parseInt(process.env.APP_PARTNER_XITI_S_PC, 10) || 104628;
var xitiSiteMobile = parseInt(process.env.APP_PARTNER_XITI_S_MOBILE, 10) || 486165;
var xitiSiteIos = parseInt(process.env.APP_PARTNER_XITI_S_APP_IOS, 10) || 513336;
var xitiSiteAndroid = parseInt(process.env.APP_PARTNER_XITI_S_APP_ANDROID, 10) || 517553;
var didomiNoticeId = process.env.DIDOMI_NOTICE_ID || 'D9fNtHCe';
var jahiaModuleIsActive = process.env.JAHIA_MODULE_IS_ACTIVE === 'true';
var jahiaCdn = process.env.APP_JAHIA_CDN || 'https://static.fr.shopping.rakuten.com';
var jahiaCdnImg = process.env.APP_JAHIA_CDN_IMG || 'https://images.fr.shopping.rakuten.com';
var googleTagManagerEnvironmentId = process.env.APP_PARTNER_GOOGLE_TAG_MANAGER_ID || 'GTM-PW57K8V';
var googleTagManagerEnvironment = process.env.PARTNER_GOOGLE_TAG_MANAGER_ENV || 'env-8';
var googleTagManagerEnvironmentParameters = process.env.PARTNER_GOOGLE_TAG_MANAGER_PARAMETERS || 'gtm_auth=a8rpa1M_hAfUi_ajMpMS6g&gtm_cookies_win=x';
var ssrPersonalize = process.env.FEATURE_FLIP_SSR_PERSONALIZE === 'true';
var obfuscation = process.env.APP_OBFUSCATION_IS_ACTIVE !== 'false';
var desktopImgNoPadExcludedCategories = process.env.DESKTOP_IMG_NOPAD_EXCLUDED_CATEGORIES
    ? JSON.parse(process.env.DESKTOP_IMG_NOPAD_EXCLUDED_CATEGORIES)
    : [];
var desktopNoPadFormat = process.env.DESKTOP_NOPAD_FORMAT || 'L_NOPAD';
var mobImgNoPadExcludedCategories = process.env.MOB_IMG_NOPAD_EXCLUDED_CATEGORIES
    ? JSON.parse(process.env.MOB_IMG_NOPAD_EXCLUDED_CATEGORIES)
    : [];
var mobNoPadFormat = process.env.MOB_NOPAD_FORMAT || 'ML_NOPAD';
var noPadControlImgEndpoint = process.env.NOPAD_CONTROLLED_IMG_ENDPOINT || null;
var adsTestCampaignON = process.env.ADS_TEST_CAMPAIGN_IS_ON === 'true' || false;
var conversationIsActive = process.env.APP_CONVERSATION_IS_ACTIVE === 'true';
var sellHomeRedirectionIsActive = process.env.SELL_HOME_REDIRECTION_ENABLED === 'true' || false;
// Next.js
var logFile = process.env.LOG_FILE || 'logs/log';
var logLevel = process.env.LOG_LEVEL || 'info';
var logFormat = process.env.LOG_FORMAT || 'json';
var port = process.env.NEXT_PORT || '3000';
var strapiTechBaseUrl = process.env.STRAPI_TECH_BASE_URL || '/restpublic/cms/tech';
var strapiTechImagesCDN = process.env.STRAPI_TECH_IMAGES_CDN || '/images/cms/tech';
var dataDomeJsKey = process.env.DATADOME_JS_KEY;
var headerPseudoOrFirstnameMaxLength = process.env.HEADER_PSEUDO_OR_FIRSTNAME_OR_EMAIL_MAX_LENGTH || '15';
// when we create cacheable HTML we need a Useragent string to use for your MD mobile Detect freature
var cacheableHtmlSSRUserAgent = process.env.CACHEABLE_HTML_SSR_USER_AGENT ||
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.81 Safari/537.36'; // Win 10 Chrome 94 most used Browser on the platform 10/2021
var processOutJsScriptUrl = process.env.PROCESSOUT_SCRIPT_URL;
var processOutProjectId = process.env.PROCESSOUT_PROJECT_ID;
var marqetaJsScriptUrl = process.env.MARQETA_SCRIPT_URL;
// Merchant center
var mcMenuAllOrdersUrl = process.env.MC_MENU_ALL_ORDERS_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/order.php?sAction=mesventes&sSubAction=avalider';
var mcMenuClaimsUrl = process.env.MC_MENU_CLAIMS_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/order.php?sAction=claims';
var mcMenuExpeditionsUrl = process.env.MC_MENU_EXPEDITION_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/order.php?sAction=shipment&sSubAction=export';
var mcMenuShippingFeesUrl = process.env.MC_MENU_SHIPPING_FEES_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/inventaire.php?sAction=category-management';
var mcMenuNumbersUrl = process.env.MC_MENU_NUMBERS_URL || 'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/chiffre.php';
var mcMenuMQSUrl = process.env.MC_MENU_MQS_URL || 'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/mqs.php';
var mcMenuAPIUrl = process.env.MC_MENU_API_URL || 'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/catalogue.php';
var mcMenuRakutenAdsUrl = process.env.MC_MENU_RAKUTEN_ADS_URL || 'https://outils.fr.shopping.rakuten.com/rakuten-ads/';
var mcMenuSuperPointsUrl = process.env.MC_MENU_SUPER_POINTS_URL || 'https://outils.fr.shopping.rakuten.com/rakuten-superpoints';
var mcMenuOrdersUrl = process.env.MC_MENU_ORDERS_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/order.php?sAction=rakuten-logistic-order';
var mcMenuFulfillmentInboundUrl = process.env.MC_MENU_FULFILLMENT_INBOUND_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/inventaire.php?sAction=rakuten-logistic-inbound-order';
var mcMenuFulfillmentInventoryUrl = process.env.MC_MENU_FULFILLMENT_INVENTORY_URL ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/inventaire.php?sAction=rakuten-logistic-inbound-product-list';
var mcMenuEshopUrl = process.env.MC_MENU_ESHOP_URL || 'https://outils.fr.shopping.rakuten.com/rakuten-superboutique/';
var mcMenuSellerGuideUrl = process.env.MC_MENU_SELLER_GUIDE_URL || 'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/conseils.php';
var mcMenuRakutenAcademyUrl = process.env.MC_MENU_RAKUTEN_ACADEMY_URL || 'https://services.fr.shopping.rakuten.com/fr/formation-et-universite/e-learning';
var mcMenuEccUrl = process.env.MC_MENU_ECC_URL || 'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/contact.php';
var mcMenuAPIDocUrl = process.env.MC_MENU_API_DOC_URL || 'https://outils.fr.shopping.rakuten.com/dev-pro/fr/';
var mcMenuMyAdsUrl = process.env.MC_MENU_MY_ADS ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/dashboard.php?page=inventaire';
var merchantCenterDefaultLocale = process.env.MC_DEFAULT_LOCALE || 'fr-FR';
var merchantCenterIsActive = process.env.MERCHANT_CENTER_ENABLED === 'true';
var merchantCenterBetaTesters = ((_a = process.env.MERCHANT_CENTER_BETATESTERS) === null || _a === void 0 ? void 0 : _a.split(';').map(Number)) || [];
var mcCurrentSalesLink = process.env.MC_CURRENT_SALES_LINK ||
    'https://outils.fr.shopping.rakuten.com/documents/merchant-dashboard/public/php/order.php?sAction=mesventes&sSubAction=encours';
var merchantOnboardingIsActive = process.env.MERCHANT_ONBOARDING_ENABLED === 'true';
var merchantCenterStrapiToken = process.env.MERCHANT_CENTER_STRAPI_TOKEN;
var merchantSellerPreferencesIsActive = process.env.MERCHANT_SELLER_PREFERENCES_ENABLED === 'true';
var merchantAccountingExportsRequestInterval = process.env.MERCHANT_ACCOUNTING_EXPORTS_REQUEST_INTERVAL || 5000;
var merchantOnboardingValidationCarouselInterval = process.env.MERCHANT_ONBOARDING_VALIDATION_CAROUSEL_INTERVAL || 5000;
var merchantAccountingExportsIsActive = process.env.MERCHANT_ACCOUNTING_EXPORTS_ENABLED === 'true';
var merchantInvoicesIsActive = process.env.MERCHANT_INVOICES_ENABLED === 'true';
// Chat
var chatIsActive = process.env.CHAT_IS_ACTIVE === 'true';
var featureFlippingSendFiles = process.env.CHAT_SEND_FILES_IS_ACTIVE === 'true';
var featureFlippingBuyerSendFiles = process.env.CHAT_BUYER_SEND_FILES_IS_ACTIVE === 'true';
var featureFlippingSendDocs = process.env.CHAT_SEND_DOCS_IS_ACTIVE === 'true';
var negotiationIsActive = process.env.NEGOTIATION_IS_ACTIVE === 'true';
var chatAppId = ((_b = process.env) === null || _b === void 0 ? void 0 : _b.CHAT_APP_ID) || '';
// Repairability index
var repairabilityIndexPdfUrl = process.env.REPAIRABILITY_INDEX_PDF_BASE_URL;
var repairabilityIndexSvgLocationPrefix = process.env.REPAIRABILITY_INDEX_SVG_LOCATION_PREFIX;
var crewAdvertInstantRedirectDesktopActive = process.env.FRICTIONLESS_MODAL_CREW_DESKTOP_IS_ACTIVE === 'true';
var crewAdvertInstantRedirectMobileActive = process.env.FRICTIONLESS_MODAL_CREW_MOB_IS_ACTIVE === 'true';
//DAC7
var featureFlippingDac7Status = process.env.FEATURE_FLIPPING_DAC7_STATUS === 'true';
var defaultConfig = {
    domainName: domainName,
    backendTechUrl: backendTechUrl,
    backendVisUrl: backendVisUrl,
    backendWsUrl: backendWsUrl,
    backendSelUrl: backendSelUrl,
    backendBuyUrl: backendBuyUrl,
    gatewayUrl: gatewayUrl,
    merchantCenterStrapiUrl: merchantCenterStrapiUrl,
    backendRfnUrl: backendRfnUrl,
    backendRefUrl: backendRefUrl,
    backendDispUrl: backendDispUrl,
    backendCompUrl: backendCompUrl,
    apiUrl: apiUrl,
    apiTech: apiTech,
    apiVis: apiVis,
    apiSeller: apiSeller,
    apiBuyer: apiBuyer,
    apiMerch: apiMerch,
    cdn: cdn,
    cdnStatic: cdnStatic,
    cdnImages: cdnImages,
    kmlEndpoint: kmlEndpoint,
    kmlIframeUrl: kmlIframeUrl,
    kmlIsActive: kmlIsActive,
    canonicalUrl: canonicalUrl,
    httpsPort: httpsPort,
    enableProxification: enableProxification,
    filterFamilyIsActive: filterFamilyIsActive,
    lazyOffsetDesktop: lazyOffsetDesktop,
    lazyOffsetMobile: lazyOffsetMobile,
    lockMaxFlux: lockMaxFlux,
    nodeInstance: nodeInstance,
    jahiaCdn: jahiaCdn,
    jahiaCdnImg: jahiaCdnImg,
    timeout: { default: defaultTimeout, long: longTimeout },
    hasCanopy: hasCanopy,
    adsTestCampaignON: adsTestCampaignON,
    featureFlipping: {
        jahiaModuleIsActive: jahiaModuleIsActive,
        ssrPersonalize: ssrPersonalize,
        obfuscation: obfuscation,
        desktopImgNoPadExcludedCategories: desktopImgNoPadExcludedCategories,
        mobImgNoPadExcludedCategories: mobImgNoPadExcludedCategories,
        desktopNoPadFormat: desktopNoPadFormat,
        mobNoPadFormat: mobNoPadFormat,
        noPadControlImgEndpoint: noPadControlImgEndpoint,
        didomiNoticeId: didomiNoticeId,
        conversationIsActive: conversationIsActive,
        sellHomeRedirectionIsActive: sellHomeRedirectionIsActive,
        merchantCenterIsActive: merchantCenterIsActive,
        merchantOnboardingIsActive: merchantOnboardingIsActive,
        merchantSellerPreferencesIsActive: merchantSellerPreferencesIsActive,
        merchantAccountingExportsIsActive: merchantAccountingExportsIsActive,
        merchantInvoicesIsActive: merchantInvoicesIsActive,
    },
    xiti: {
        desktop: xitiSiteDesktop,
        mobile: xitiSiteMobile,
        iOS: xitiSiteIos,
        android: xitiSiteAndroid,
    },
    partner: {
        googleTagManager: {
            id: googleTagManagerEnvironmentId,
            parameters: googleTagManagerEnvironmentParameters,
            env: googleTagManagerEnvironment,
        },
        kameleoon: {
            endpoint: kmlEndpoint,
            iframUrl: kmlIframeUrl,
            isActive: kmlIsActive,
        },
    },
    googleTagManagerEnvironmentId: googleTagManagerEnvironmentId,
    googleTagManagerEnvironmentParameters: googleTagManagerEnvironmentParameters,
    googleTagManagerEnvironment: googleTagManagerEnvironment,
    strapiTechBaseUrl: strapiTechBaseUrl,
    strapiTechImagesCDN: strapiTechImagesCDN,
    apiStrapi: apiStrapi,
    dataDomeJsKey: dataDomeJsKey,
    cacheableHtmlSSRUserAgent: cacheableHtmlSSRUserAgent,
    marqetaJsScriptUrl: marqetaJsScriptUrl,
    processOut: {
        url: processOutJsScriptUrl,
        project: processOutProjectId,
    },
    merchantCenterMenuUrls: {
        mcMenuAllOrdersUrl: mcMenuAllOrdersUrl,
        mcMenuClaimsUrl: mcMenuClaimsUrl,
        mcMenuExpeditionsUrl: mcMenuExpeditionsUrl,
        mcMenuShippingFeesUrl: mcMenuShippingFeesUrl,
        mcMenuNumbersUrl: mcMenuNumbersUrl,
        mcMenuMQSUrl: mcMenuMQSUrl,
        mcMenuAPIUrl: mcMenuAPIUrl,
        mcMenuRakutenAdsUrl: mcMenuRakutenAdsUrl,
        mcMenuSuperPointsUrl: mcMenuSuperPointsUrl,
        mcMenuOrdersUrl: mcMenuOrdersUrl,
        mcMenuFulfillmentInboundUrl: mcMenuFulfillmentInboundUrl,
        mcMenuFulfillmentInventoryUrl: mcMenuFulfillmentInventoryUrl,
        mcMenuEshopUrl: mcMenuEshopUrl,
        mcMenuSellerGuideUrl: mcMenuSellerGuideUrl,
        mcMenuRakutenAcademyUrl: mcMenuRakutenAcademyUrl,
        mcMenuEccUrl: mcMenuEccUrl,
        mcMenuAPIDocUrl: mcMenuAPIDocUrl,
        mcMenuMyAdsUrl: mcMenuMyAdsUrl,
    },
    merchantCenterDefaultLocale: merchantCenterDefaultLocale,
    merchantCenterBetaTesters: merchantCenterBetaTesters,
    mcCurrentSalesLink: mcCurrentSalesLink,
    merchantCenterStrapiToken: merchantCenterStrapiToken,
    merchantAccountingExportsRequestInterval: merchantAccountingExportsRequestInterval,
    merchantOnboardingValidationCarouselInterval: merchantOnboardingValidationCarouselInterval,
    chat: {
        chatIsActive: chatIsActive,
        featureFlippingSendFiles: featureFlippingSendFiles,
        featureFlippingBuyerSendFiles: featureFlippingBuyerSendFiles,
        featureFlippingSendDocs: featureFlippingSendDocs,
        negotiationIsActive: negotiationIsActive,
        appId: chatAppId,
    },
    repairabilityIndex: {
        repairabilityIndexPdfUrl: repairabilityIndexPdfUrl,
        repairabilityIndexSvgLocationPrefix: repairabilityIndexSvgLocationPrefix,
    },
    advertCrewModale: {
        instantRedirectDesktopActive: crewAdvertInstantRedirectDesktopActive,
        instantRedirectMobileActive: crewAdvertInstantRedirectMobileActive,
    },
};
function get() {
    return Object.assign({}, defaultConfig);
}
exports.get = get;
// for nextJS
exports.serverRuntimeConfig = {
    apiUrl: apiUrl,
    apiVis: apiVis,
    apiBuyer: apiBuyer,
    apiMerch: apiMerch,
    apiSeller: apiSeller,
    enableProxification: enableProxification,
    enableBackendHttpProxy: enableBackendHttpProxy,
    enableBackendHttpProxyServerUrl: enableBackendHttpProxyServerUrl,
    backendTechUrl: backendTechUrl,
    backendVisUrl: backendVisUrl,
    backendSelUrl: backendSelUrl,
    backendBuyUrl: backendBuyUrl,
    gatewayUrl: gatewayUrl,
    merchantCenterStrapiUrl: merchantCenterStrapiUrl,
    backendRfnUrl: backendRfnUrl,
    backendRefUrl: backendRefUrl,
    backendDispUrl: backendDispUrl,
    backendCompUrl: backendCompUrl,
    strapiTechBaseUrl: strapiTechBaseUrl,
    strapiTechImagesCDN: strapiTechImagesCDN,
    kmlEndpoint: kmlEndpoint,
    kmlIframeUrl: kmlIframeUrl,
    kmlIsActive: kmlIsActive,
    googleTagManagerEnvironmentId: googleTagManagerEnvironmentId,
    googleTagManagerEnvironmentParameters: googleTagManagerEnvironmentParameters,
    googleTagManagerEnvironment: googleTagManagerEnvironment,
    logLevel: logLevel,
    logFile: logFile,
    logFormat: logFormat,
    port: port,
    canonicalUrl: canonicalUrl,
    apiStrapi: apiStrapi,
    cacheableHtmlSSRUserAgent: cacheableHtmlSSRUserAgent,
    marqetaJsScriptUrl: marqetaJsScriptUrl,
    processOut: {
        url: processOutJsScriptUrl,
        project: processOutProjectId,
    },
    merchantCenterMenuUrls: {
        mcMenuAllOrdersUrl: mcMenuAllOrdersUrl,
        mcMenuClaimsUrl: mcMenuClaimsUrl,
        mcMenuExpeditionsUrl: mcMenuExpeditionsUrl,
        mcMenuShippingFeesUrl: mcMenuShippingFeesUrl,
        mcMenuNumbersUrl: mcMenuNumbersUrl,
        mcMenuMQSUrl: mcMenuMQSUrl,
        mcMenuAPIUrl: mcMenuAPIUrl,
        mcMenuRakutenAdsUrl: mcMenuRakutenAdsUrl,
        mcMenuSuperPointsUrl: mcMenuSuperPointsUrl,
        mcMenuOrdersUrl: mcMenuOrdersUrl,
        mcMenuFulfillmentInboundUrl: mcMenuFulfillmentInboundUrl,
        mcMenuFulfillmentInventoryUrl: mcMenuFulfillmentInventoryUrl,
        mcMenuEshopUrl: mcMenuEshopUrl,
        mcMenuSellerGuideUrl: mcMenuSellerGuideUrl,
        mcMenuRakutenAcademyUrl: mcMenuRakutenAcademyUrl,
        mcMenuEccUrl: mcMenuEccUrl,
        mcMenuAPIDocUrl: mcMenuAPIDocUrl,
    },
    merchantCenterDefaultLocale: merchantCenterDefaultLocale,
    merchantCenterBetaTesters: merchantCenterBetaTesters,
    mcCurrentSalesLink: mcCurrentSalesLink,
    merchantCenterStrapiToken: merchantCenterStrapiToken,
    merchantAccountingExportsRequestInterval: merchantAccountingExportsRequestInterval,
    merchantOnboardingValidationCarouselInterval: merchantOnboardingValidationCarouselInterval,
    repairabilityIndexPdfUrl: repairabilityIndexPdfUrl,
    repairabilityIndexSvgLocationPrefix: repairabilityIndexSvgLocationPrefix,
    dac7: {
        featureFlippingDac7Status: featureFlippingDac7Status,
    },
    advertCrewModale: {
        instantRedirectDesktopActive: crewAdvertInstantRedirectDesktopActive,
        instantRedirectMobileActive: crewAdvertInstantRedirectMobileActive,
    },
};
// on server side load config from env, in browser load config from window.PUBLIC_RUNTIME_CONFIG, this is added in nextjs in pages/_document.tsx
exports.publicRuntimeConfig = {
    cdnImages: typeof window !== 'undefined' ? ((_c = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _c === void 0 ? void 0 : _c.cdnImages) || cdnImages : cdnImages,
    timeout: {
        default: typeof window !== 'undefined' ? ((_e = (_d = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _d === void 0 ? void 0 : _d.timeout) === null || _e === void 0 ? void 0 : _e.default) || defaultTimeout : defaultTimeout,
        long: typeof window !== 'undefined' ? ((_g = (_f = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _f === void 0 ? void 0 : _f.timeout) === null || _g === void 0 ? void 0 : _g.long) || longTimeout : longTimeout,
    },
    header: {
        firstNameOrPseudoMaxLength: typeof window !== 'undefined'
            ? ((_h = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _h === void 0 ? void 0 : _h.header.firstNameOrPseudoMaxLength) || headerPseudoOrFirstnameMaxLength
            : headerPseudoOrFirstnameMaxLength,
    },
    featureFlipping: {
        ssrPersonalize: typeof window !== 'undefined' ? ((_j = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _j === void 0 ? void 0 : _j.featureFlipping.ssrPersonalize) || ssrPersonalize : ssrPersonalize,
    },
    canonicalUrl: typeof window !== 'undefined' ? ((_k = window === null || window === void 0 ? void 0 : window.PUBLIC_RUNTIME_CONFIG) === null || _k === void 0 ? void 0 : _k.canonicalUrl) || canonicalUrl : canonicalUrl,
};
/**
 * temporary
 */
function loadConfiguration() {
    return Promise.resolve(get());
}
exports.loadConfiguration = loadConfiguration;
exports.configService = { get: get, loadConfiguration: loadConfiguration, serverRuntimeConfig: exports.serverRuntimeConfig, publicRuntimeConfig: exports.publicRuntimeConfig };
